import React, { createContext, useState, useEffect } from 'react';
import axiosInstance from '../axiosConfig';
import { decodeToken, isTokenExpired } from '../utils/tokenUtils';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');

    if (storedUser) {
      try {
        return JSON.parse(storedUser);
      } catch (error) {
        console.error('Error parsing stored user:', error);
      }
    }

    const storedToken = localStorage.getItem('token');

    if (storedToken && !isTokenExpired(storedToken)) {
      const payload = decodeToken(storedToken);
      if (payload?.user) {
        localStorage.setItem('user', JSON.stringify(payload.user));
        return payload.user;
      }
    }

    return null;
  });
  const [token, setToken] = useState(() => {
    const storedToken = localStorage.getItem('token');
    // Verifica se il token è scaduto
    if (storedToken && isTokenExpired(storedToken)) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return null;
    }
    return storedToken;
  });
  const [csrfToken, setCsrfToken] = useState('');

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
    window.location.href = '/login';
  };

  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await axiosInstance.get('/api/csrf-token');
        setCsrfToken(response.data.csrfToken);
        axiosInstance.defaults.headers.post['x-csrf-token'] = response.data.csrfToken;
        axiosInstance.defaults.headers.put['x-csrf-token'] = response.data.csrfToken;
        axiosInstance.defaults.headers.delete['x-csrf-token'] = response.data.csrfToken;
      } catch (err) {
        console.error('Error fetching CSRF token:', err);
      }
    };

    fetchCsrfToken();
  }, []);

  // Controlla periodicamente se il token è scaduto
  useEffect(() => {
    if (!token) return;

    const checkTokenExpiration = () => {
      if (isTokenExpired(token)) {
        console.log('Token expired, logging out...');
        logout();
      }
    };

    // Controlla subito
    checkTokenExpiration();

    // Controlla ogni minuto
    const interval = setInterval(checkTokenExpiration, 60000);

    return () => clearInterval(interval);
  }, [token]);

  useEffect(() => {
    if (!token) {
      setUser(null);
      localStorage.removeItem('user');
      return;
    }

    const payload = decodeToken(token);

    if (payload?.user) {
      setUser(payload.user);
      localStorage.setItem('user', JSON.stringify(payload.user));
    } else {
      setUser(null);
      localStorage.removeItem('user');
    }
  }, [token]);

  return (
    <AuthContext.Provider value={{ user, setUser, token, setToken, csrfToken, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
